import { render, staticRenderFns } from "./InviteFriendsModal.vue?vue&type=template&id=36cc3a27&lang=pug&"
import script from "./InviteFriendsModal.vue?vue&type=script&lang=js&"
export * from "./InviteFriendsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports